import Vue from 'vue'
import Cookies from 'vue-cookies'

Vue.use(Cookies)

// never expire cookies
Cookies.config(Infinity)
